<template lang="pug">
    div
        template(v-if="!isEdit")
            template(v-if="field !== 'phone'")
                p.cursor-pointer(@click="() => { if (isActive) onEdit() }") {{ item[field] }} 
                    template(v-if="isActive")
                        span &#9998;
            template(v-if="field === 'phone'")
                .flex.justify-center
                    template(v-if="item[field]")
                        .text-center.font-medium(@click="() => { if (isActive) onEdit() }") {{onFormatPhone({phone: item[field]})}} 
                            template(v-if="isActive")
                                span &#9998;
                    template(v-else)
                        .text-center(@click="() => { if (isActive) onEdit() }") добавить номер &#9998;
        template(v-else)
            edit-input-wrapper( @cancel="onCancelEdit" @accept="onSave(item)" )
                text-area(:value="item[field]" @value="value = $event" :placeholder="placeholder")
</template>

<script>
//Components
import TextArea from '@/components/common/forms/text-area';
import EditInputWrapper from '@/components/common/forms/edit-wrapper';
//Helpers
import { onFormatPhone } from '@/helpers/format-phone';
//Store
/* eslint-disable no-unused-vars */
import { UsersNameSpace, UsersActionTypes } from '@/store/users/types';
import { RecipientsNameSpace, RecipientsActionTypes } from '@/store/recipients/types';

export default {
    name: 'DefaultUserField',
    components: {
        'text-area': TextArea,
        'edit-input-wrapper': EditInputWrapper,
    },
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        context: {
            type: Object,
            default: () => ({
                name_space: 'users',
                action: 'EditUser',
            }),
        },
        field: {
            type: String,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: true,
        },
        placeholder: {
            type: String,
        },
    },
    data() {
        return {
            isEdit: false,
            value: this.item[this.field],
        }
    },
    methods: {
        onEdit() {
            this.isEdit = !this.isEdit
        },
        onCancelEdit() {
            this.isEdit = !this.isEdit
        },
        async onFieldChange({ id }) {
            await this.$store.dispatch(`${this.context.name_space}/${this.context.action}`, { id, value: {[this.field]:this.value} })
            this.$emit('updated')
            this.isEdit = !this.isEdit
        },
        onSave({ _id }) {
            this.onFieldChange({ id: _id })
        },
        onFormatPhone({phone}) {
            return onFormatPhone({phone})
        }
    },
}
</script>